import { render, staticRenderFns } from "./Rendimentos.vue?vue&type=template&id=99996a1e"
import script from "./Rendimentos.vue?vue&type=script&lang=js"
export * from "./Rendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports